import React, { useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  InputAdornment,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import _ from "lodash";
import SearchIcon from "@mui/icons-material/Search";
import * as Yup from "yup";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { useStyles } from "./styles";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../assets/images/CourseManagement/close.svg";
import useStudent from "../../../Hooks/student";
import Loader from "../../../common/Loader";
import { useNavigate } from "react-router-dom";
import { ErrorMessage, Formik } from "formik";
import useCourse from "../../../Hooks/course";
import DeleteModal from "../../../common/DeleteModal";
import usePagination from "../../../common/usePagination";
import CustomPagination from "../../../common/Pagination";
import { useCallback } from "react";
import useAuthStore from "../../../Hooks/auth";
import ToggleSwitch from "../../../common/ToggleSwitch";
import { getStatusInBoolen, getToggleStatus } from "../../../Utils/deleteutils";

const columns = [
  {
    id: "regNumber",
    sortby: true,
    label: "Registration Number",
    align: "center",
    role: ["admin", "Staff"],
  },
  {
    id: "studentName",
    sortby: true,
    label: "Student Name",
    align: "center",
    role: ["admin", "Staff"],
  },
  {
    id: "departmentName",
    label: "Department",
    align: "center",
    sortby: true,
    role: ["admin", "Staff"],
  },
  {
    id: "edit",
    label: "Edit",
    align: "center",
    role: ["admin"],
  },
  {
    id: "delete",
    label: "Status",
    align: "center",
    role: ["admin"],
  },
];

const SearchValidationSchema = Yup.object().shape({
  idDepartment: Yup.string().required("* Please select the department"),
});

const StudentList = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  // const [page, setPage] = useState(1);
  // const [perPage, setPerPage] = useState(10);
  // const [offset, setOffset] = useState(0);
  const [state, setState] = useState({
    regNumber: "",
    idDepartment: "",
    institutionId: "",
  });
  const [check, setCheck] = useState("");
  const [deleteStatus, setDeleteStatus] = React.useState();
  const {
    studentData,
    searchStudentService,
    loading,
    resetStudentPersonalInfoAction,
    deleteStudentInfoAction,
    activeStudent,
    setActiveStudentAction,
    resetProfileCompletenessAction,
    perPage,
    offset,
    setPerPageAction,
    setOffsetAction,
    page,
    setPageAction,
  } = useStudent();
  const { role } = useAuthStore();
  const handleOpen = () => {
    setOpen(true);
  };

  const handlePage = (e) => {
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
    // setPage(1);
    // setOffset(0);
  };

  const { getDepartmentAction, departmentData } = useCourse();
  const { institutionId } = useAuthStore();

  const count =
    studentData &&
    Math.ceil(studentData?.totalNoOfRecord?.totalNoOfRecords / perPage);
  const _DATA = usePagination(studentData?.student, perPage);

  const handleChangepage = useCallback(
    (e, p) => {
      // setPage(p);
      // setOffset(p * perPage - perPage);
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      _DATA.jump(p);
    },
    [perPage,page, studentData]
  );
  
  const searchSchema = {
    regNumber: "",
    idDepartment: "",
    institutionId,
  };
  

  React.useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);

  React.useEffect(() => {
    const abortController = new AbortController();
    let studentSearch = {
      idDepartment: state.idDepartment,
      idStudent: "",
      sortBy: "",
      regNumber: state.regNumber,
      orderBy: "asc",
      limit: perPage,
      offset: offset,
      institutionId,
    };
    searchStudentService({ studentSearch, signal: abortController.signal });
    return () => {
      abortController.abort();
    };
  }, [perPage,page, offset,state]);

  const handleSearchFunction = (values) => {
    // setPage(1);
    // setOffset(0);
    setPageAction(1);
    setOffsetAction(0);
    setState({
      regNumber: values.regNumber,
    idDepartment: values.idDepartment,
    institutionId: values.institutionId,
    })
  }

  const handleSearch = useCallback(
    (e) => {
      const abortController = new AbortController();
      let studentSearch = {
        idDepartment: "",
        idStudent: "",
        regNumber: e.target.value,
        sortBy: "",
        orderBy: "asc",
        limit: perPage,
        offset: offset,
        institutionId,
      };
      searchStudentService({ studentSearch, signal: abortController.signal });
      if (e.keyCode == 13) {
        searchStudentService({
          studentSearch,
          signal: abortController.signal,
        });
      }
      return () => {
        abortController.abort();
      };
    },
    [perPage, offset]
  );

  const handleSearchAction = useCallback((value) => {
    const abortController = new AbortController();
    let studentSearch = {
      idDepartment: "",
      idStudent: "",
      regNumber: value,
      sortBy: "",
      orderBy: "asc",
      limit: perPage,
      offset: offset,
      institutionId,
    };
    searchStudentService({ studentSearch, signal: abortController.signal });
    return () => {
      abortController.abort();
    };
  }, []);

  const addNewStudent = () => {
    navigate("/studentManagement/add");
    resetStudentPersonalInfoAction();
    resetProfileCompletenessAction();
  };

  const _renderStudentDetails = () => {
    let studentData = [];

    studentData = columns.filter((item) => item.role.includes(role));
    // } else {
    //   studentData = columns;
    // }
    return studentData;
  };

  return (
    <>
      {loading && <Loader />}

      <Grid container className={classes.staffManagement}>
        <Grid item lg={9} sm={12}>
          <Formik
            initialValues={searchSchema}
            validationSchema={SearchValidationSchema}
            validateOnBlur={false}
            validateOnChange={false}
            enableReinitialize
            onSubmit={(values) => {
              handleSearchFunction(values)
              // searchStudentService({
              //   studentSearch: {
              //     idStudent: "",
              //     sortBy: "",
              //     orderBy: "asc",
              //     limit: perPage,
              //     offset: 0,
              //     ...values,
              //     institutionId,
              //   },
              // });
            }}
          >
            {(formik) => {
              const { errors, touched, handleChange, handleSubmit, values } =
                formik;
              return (
                <>
                  <form onSubmit={handleSubmit}>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                      gap={2}
                    >
                      <Stack
                        sx={{
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        gap={1}
                      >
                        <Typography className={classes.student_id}>
                          Registration Number
                        </Typography>
                        <TextField
                          id="regNumber"
                          name="regNumber"
                          placeholder="Search Student"
                          type={"text"}
                          sx={{
                            marginLeft: "0px !important",
                            width: "220px !important",
                          }}
                          className={
                            errors.firstName && touched.firstName
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onChange={(e) => {
                            handleChange(e);
                            // handleSearch(e);
                          }}
                          // onKeyDown={(e) => {
                          //   // handleSearch(e);
                          // }}
                          value={values.regNumber}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                position="start"
                              // sx={{ cursor: "pointer" }}
                              >
                                <SearchIcon
                                // role="button"
                                // onClick={() =>
                                //   handleSearchAction(values.regNumber)
                                // }
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                        <ErrorMessage
                          name="regNumber"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                      <Stack
                        sx={{
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          // py: 2,
                        }}
                        gap={1}
                      >
                        <Typography className={classes.student_id}>
                          Department
                        </Typography>
                        <Select
                          id="idDepartment"
                          name="idDepartment"
                          placeholder="what's your favourite car?"
                          className={
                            errors.idDepartment && touched.idDepartment
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          value={values.idDepartment}
                          onChange={handleChange}
                          IconComponent={CustomExpandMore}
                          sx={{
                            width: 200,
                            marginLeft: "0px !important",
                          }}
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            <span>Select Department</span>
                          </MenuItem>
                          {departmentData?.map((_el, index) => (
                            <MenuItem value={_el.id} key={index}>
                              {_el.name}
                            </MenuItem>
                          ))}
                        </Select> 
                      </Stack>
                    </Stack>
                    <Stack
                          sx={{
                            flexDirection: "column",
                            alignItems: "start",
                            justifyContent: "start",
                            // py: 2,
                          }}
                          gap={1}
                        >
                          <ErrorMessage
                            name="idDepartment"
                            component="span"
                            className={classes.error}
                          />
                      </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                      gap={2}
                    >
                      <Stack
                        sx={{
                          py: 2,
                        }}
                      >
                        <Button
                          type="submit"
                          sx={{
                            px: 1,
                            py: 1,
                            borderRadius: "50px",
                            minWidth: "186px !important",
                          }}
                          className={classes.search_btn}
                        >
                          Search
                        </Button>
                      </Stack>
                    </Stack>
                  </form>
                </>
              );
            }}
          </Formik>

          <Stack sx={{ my: 2 }}>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <Stack
                    sx={{
                      flexDirection: "row",
                      justifyContent: "flex-end",
                      py: 2,
                    }}
                    className={classes.add_new_staff_container}
                  >
                    {role === "admin" && (
                      <Button
                        type="submit"
                        sx={{ px: 1, py: 1, borderRadius: "50px" }}
                        className={classes.add_new_staff}
                        onClick={addNewStudent}
                      >
                        Add new Student
                      </Button>
                    )}
                  </Stack>
                  <TableContainer sx={{ maxHeight: 440 }}>
                    <Table
                      aria-label="sticky table"
                      className={classes.root}
                      style={{ padding: 0 }}
                      stickyHeader
                    >
                      <TableHead>
                        <TableRow classes={{ root: classes.thead }}>
                          {_renderStudentDetails().map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                                paddingLeft: column.paddingLeft,
                              }}
                              classes={{ root: classes.columnData }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody classes={{ root: classes.tBody }} sx={{}}>
                        {studentData?.student?.length > 0 ? (
                          _DATA.currentData()?.map((_el, index) => (
                            <TableRow key={index}>
                              {_renderStudentDetails().map((column) => {
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {column.id === "s.no" ? (
                                      <span>{index + 1}</span>
                                    ) : column.id === "regNumber" ? (
                                      _el.regNumber
                                    ) : column.id === "studentName" ? (
                                      `${_el.firstName} ${_el.lastName}`
                                    ) : column.id === "departmentName" ? (
                                      _el.departmentName
                                    ) : column.id === "edit" ? (
                                      role === "admin" && (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            navigate(
                                              "/studentManagement/edit",
                                              {
                                                state: {
                                                  idStudent: _el.idStudent,
                                                  regNumber: _el.regNumber,
                                                },
                                              }
                                            );
                                            setActiveStudentAction(
                                              _el.idStudent
                                            );
                                          }}
                                        >
                                          <img src={Pen} alt="pen" />
                                        </Stack>
                                      )
                                    ) : (
                                      role === "admin" && (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setActiveStudentAction(
                                              _el.idStudent
                                            );
                                            handleOpen();
                                            setCheck(
                                              getToggleStatus(_el.status)
                                            );
                                            setDeleteStatus(
                                              getToggleStatus(_el.status)
                                            );
                                          }}
                                        >
                                          <ToggleSwitch
                                            defaultChecked
                                            checked={getStatusInBoolen(
                                              _el.status
                                            )}
                                          />
                                        </Stack>
                                      )
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={columns.length}
                              sx={{ borderBottom: "none" }}
                            >
                              <Stack
                                sx={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                No Data
                              </Stack>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {studentData?.totalNoOfRecord?.totalNoOfRecords > 10 && (
                    <CustomPagination
                      count={count}
                      page={page}
                      onPageChange={handleChangepage}
                      handlePage={handlePage}
                      perPage={perPage}
                    />
                  )}
                </Stack>
              </Paper>
            </Box>
          </Stack>
        </Grid>
        <Grid item lg={4} sm={12}></Grid>
      </Grid>
      <DeleteModal
        setOpen={setOpen}
        open={open}
        deleteAction={deleteStudentInfoAction}
        active={activeStudent}
        textmsg={
          check === "Deleted"
            ? "Are you sure want to Deactivate this student?"
            : "Are you sure want to Active this student?"
        }
        component={"student"}
        status={deleteStatus}
      />
    </>
  );
};

export default StudentList;
